import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { cleanRoom } from 'utils/urlConstants';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';

/**
 * Fetches runtime parameter taxonomy for a clean room
 */
export const useGetCleanRoomRuntimeParameterTaxonomy = ({
  crId,
  enabled = true,
  filters = {},
  pagination = { limit: 50, offset: 0 },
  search = '',
}) => {
  const orgID = useSelector(activeOrgSelector);

  return useQuery(
    ['cleanRoomRuntimeParameterTaxonomy', orgID, crId, filters, pagination, search],
    async () => {
      const payload = {
        limit: pagination.limit,
        offset: pagination.offset,
        search,
        filters: Object.keys(filters).reduce((acc, key) => {
          if (filters[key]) acc.push(`${key}:${filters[key]}`);
          return acc;
        }, []),
      };

      const res = await axiosInstance.post(
        cleanRoom(orgID).runtimeParameterTaxonomy(crId),
        payload,
      );
      return res.data;
    },
    {
      enabled: enabled && !!crId && !!orgID,
      // Keeps old data while fetching new data
      keepPreviousData: true,
      select: (res) => ({
        runtimeParameters: res?.runtimeParameters || [],
        count: res?.count || 0,
      }),
    },
  );
};
